export var dateISOString = new Date(+new Date() + 864e5).toISOString();
export var xAmzDate = dateISOString.split('-').join('').split(':').join('').split('.').join('');
export var dateYMD = dateISOString.split('T')[0].split('-').join('');